/** @file Kinds of pickable curve-graph points (keys and handles beat curve samples in a pick). */

/** Curve sample (picks its track), key, bezier handle. */
export const CURVE_POINT = { sample: 0, key: 1, handle: 2 } as const;
